var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Error',{attrs:{"title":"ページにアクセスできません","lead":"会員証QRコードの有効期限が切れています"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._v("\n    更新されたQRコードをもう一度読み取ってください。\n  ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }